// extracted by mini-css-extract-plugin
export default {"iframe":"dashboard_iframe__HHw9g"};